import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-warm flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-serif font-bold text-slate mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-slate mb-4">Trail Not Found</h2>
        <p className="text-gray-600 mb-8">
          This path doesn't exist. Let's get you back on track.
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-3 bg-forest text-warm font-semibold rounded-lg hover:bg-forest-light transition-colors"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}
